import { render } from "./BillingTable.vue?vue&type=template&id=5c1f86bb"
import script from "./BillingTable.vue?vue&type=script&lang=js"
export * from "./BillingTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__